import { useClientConfiguration } from "../data/global/useProductConfiguration";

const useHasAdtMktTrxTrans = (client: string) => {
  const config = useClientConfiguration(client);

  return config.hasAdtMktTrxTrans;
};

export default useHasAdtMktTrxTrans;
